module.exports = {
      id: "icon-link-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-link",
      toString: function () {
        return this.url;
      }
    }